export default {
      id: "MMB_1x-usage",
      viewBox: "0 0 28 36",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#MMB_1x",
      toString: function () {
        return this.url;
      }
    }